import { observer } from 'mobx-react';
import * as Portal from '@radix-ui/react-portal';
import IconButton, { ICON_BUTTON_ICONS } from '../../../../../components/buttons/IconButton';

/**
 * ProfilerHowToPopup - How-to guide popup for Profiler search
 *
 * Displays instructions on using the different search types:
 * - Characteristics search (industry, value chain, product portfolio)
 * - Industry search (sector-based)
 * - Name search (direct company lookup)
 *
 * @param {boolean} isOpen - Whether the popup is visible
 * @param {function} onClose - Callback to close the popup
 */
const ProfilerHowToPopup = observer(({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <Portal.Root>
      <div className="how-to-profiler-search-popup-closer"></div>
      <div className="how-to-profiler-search-popup-wrapper">
        <div className="how-to-profiler-search-popup">
          <div className="header">
            <div className="title">How to use the searches?</div>
            <IconButton
              id="close-how-to-profiler-search-popup"
              withFill={false}
              withBorder={false}
              icon={ICON_BUTTON_ICONS.X_LG}
              onClick={onClose}
            />
          </div>
          <div className="text-content">
            <div className="row">
              You can either search via{' '}
              <span className="highlight-how-to-profiler-search">target characteristics</span>,{' '}
              <span className="highlight-how-to-profiler-search">industries</span>, or{' '}
              <span className="highlight-how-to-profiler-search">name</span>.
            </div>
            <div className="row">
              The <span className="highlight-how-to-profiler-search">characteristics search</span>{' '}
              is based on a target's{' '}
              <span className="highlight-how-to-profiler-search">industry</span> (e.g., Industrial
              IoT, Smart Industries),{' '}
              <span className="highlight-how-to-profiler-search">value chain position</span> (e.g.,
              Manufacturer), and{' '}
              <span className="highlight-how-to-profiler-search">product portfolio</span> (e.g.,
              Automation, Remote Monitoring).
              <br />
              <span className="hint-how-to-profiler-search">
                Hint: Think of it like a funnel – the more specific your keywords and the more
                keywords provided, the more specific the results.
              </span>
            </div>
            <div className="row">
              The <span className="highlight-how-to-profiler-search">industry search</span> is based
              on a company's overall sector. It helps you map markets or explore entire segments
              based on standard industry definitions.
            </div>
            <div className="row">
              The <span className="highlight-how-to-profiler-search">name search</span> is simple –
              just type the name of the company you're looking for.
            </div>
          </div>
        </div>
      </div>
    </Portal.Root>
  );
});

export default ProfilerHowToPopup;
